import { useState, useEffect } from 'react'
import {
  isMobile,
  isSmallish,
  isTablet,
  isDesktop,
} from '../../utils/getBreakpoint'
import { window } from './window'

export function useBreakpoint() {
  const [mobile, setMobile] = useState(false)
  const [smallish, setSmallish] = useState(false)
  const [tablet, setTablet] = useState(false)
  const [desktop, setDesktop] = useState(false)

  useEffect(() => {
    function handleWidth() {
      const windowWidth = window ? window.innerWidth : 0
      const mobileWidth = isMobile(windowWidth)
      const smallishWidth = isSmallish(windowWidth)
      const tabletWidth = isTablet(windowWidth)
      const desktopWidth = isDesktop(windowWidth)

      setMobile(mobileWidth)
      setSmallish(smallishWidth)
      setTablet(tabletWidth)
      setDesktop(desktopWidth)
    }

    window.addEventListener('resize', handleWidth)

    handleWidth()

    return () => {
      window.removeEventListener('resize', handleWidth)
    }
  })

  return { mobile, smallish, tablet, desktop }
}
